/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateKeyValueResponse
 */
export interface CreateKeyValueResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateKeyValueResponse
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateKeyValueResponse
     */
    expires?: Date | null;
}

/**
 * Check if a given object implements the CreateKeyValueResponse interface.
 */
export function instanceOfCreateKeyValueResponse(value: object): value is CreateKeyValueResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CreateKeyValueResponseFromJSON(json: any): CreateKeyValueResponse {
    return CreateKeyValueResponseFromJSONTyped(json, false);
}

export function CreateKeyValueResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateKeyValueResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'expires': json['expires'] == null ? undefined : (new Date(json['expires'])),
    };
}

export function CreateKeyValueResponseToJSON(json: any): CreateKeyValueResponse {
    return CreateKeyValueResponseToJSONTyped(json, false);
}

export function CreateKeyValueResponseToJSONTyped(value?: CreateKeyValueResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'expires': value['expires'] == null ? value['expires'] : value['expires'].toISOString(),
    };
}

